import { useGridApiRef7 } from "../../platform-style";
import { GridRowId } from "@mui/x-data-grid-pro";
import { useEffect } from "react";

/**
 * @deprecated Use useGridApiRef7 instead.
 */
export const useGridApiRef = () => {
  const apiRef = useGridApiRef7();

  const getVisibleRowModels = (): Array<Array<GridRowId>> => {
    // @ts-ignore
    const allRowIds: GridRowId[] = apiRef.current.getAllRowIds();
    const allRows = [];

    for (const row of allRowIds) {
      // @ts-ignore
      allRows.push([row]);
    }

    return allRows;
  };

  useEffect(() => {
    // @ts-ignore
    // noinspection JSConstantReassignment
    apiRef.current = { ...apiRef.current, getVisibleRowModels };
  });

  return apiRef;
};
